import {Exchange} from "../../instruments/exchange/Exchange";
import {OffsetDateTime} from "../../pseudo-types/DateTypes";
import {AccountName} from "./SimpleAccountTypes";
import {AccountId} from "./AccountRecord";

export type ContractNoteRecords = ReadonlyArray<ContractNoteRecord>;

export interface ContractNoteRecord {
    readonly organisationCode: string;
    readonly branchCode: string;
    readonly advisorCode: string;
    readonly accountNumber: AccountId;
    readonly accountName: AccountName;
    readonly referenceNumber: string;
    readonly contractDate: OffsetDateTime;
    readonly asAtDate: OffsetDateTime;
    readonly settleDate: OffsetDateTime;
    readonly securityCode: string;
    readonly securityDescription: string;
    readonly marketCode: Exchange;
    readonly isin: string;
    readonly buySell: ContractNoteSide;
    readonly quantity: number;
    readonly consideration: number;
    readonly averagePrice: number;
    readonly brokerage: number;
    readonly adminFee: number;
    readonly gst: number;
    readonly exchangeFee: number;
    readonly tradeCurrency: string;
    readonly settleCurrency: string;
    readonly exchangeRate: number;
    readonly nettTradeAmount: number;
    readonly nettSettleAmount: number;
    readonly status: ContractNoteStatus;
    readonly stockSettlementMethod: string;
    readonly cashSettlementMethod: string;
    readonly matchStatus: MatchStatus;
    readonly unsettledQuantity: number;
    readonly unsettledAmount: number;
    readonly finalStockSettleDate: string;
    readonly finalCashSettleDate: string;
}

export enum ContractNoteSide {
    BUY = "BUY",
    SELL = "SELL"
}

export function contractNoteSideName(side: ContractNoteSide): string {
    switch (side) {
        case ContractNoteSide.BUY:
            return "Buy";
        case ContractNoteSide.SELL:
            return "Sell";
    }
}

export enum ContractNoteStatus {
    OPEN = "OPEN",
    UNSETTLED = "UNSETTLED",
    SETTLED = "SETTLED",
    CANCELLED = "CANCELLED",
    REVERSED = "REVERSED"
}

export function contractNoteStatusName(status: ContractNoteStatus): string {
    switch (status) {
        case ContractNoteStatus.CANCELLED:
            return "Cancelled";
        case ContractNoteStatus.OPEN:
            return "Open";
        case ContractNoteStatus.REVERSED:
            return "Reversed";
        case ContractNoteStatus.SETTLED:
            return "Settled";
        case ContractNoteStatus.UNSETTLED:
            return "Unsettled";
    }
}

export enum MatchStatus {
    UNMATCH= "UNMATCH",
    MATCH = "MATCH"
}
